export default [
  {
    "name": "Project Initialized",
    "description": "Laying the foundation for everythiing to rest upon. First commit! (Not the launch)",
    "status": "Completed",
    "year": "2021",
    "tag": "Blockchain",
    "priority": "High",
    "quarter": "Q1"
  },
  {
    "name": "BlockDAG Implementation",
    "description": "Use DAG structure instead of linear blockchain.",
    "status": "Completed",
    "year": "2023",
    "tag": "Blockchain",
    "priority": "High",
    "quarter": "Q2"
  },
  {
    "name": "XSWD",
    "description": "Permissioned protocol that uses WebSocket to exchange data between wallet and dApp.",
    "status": "Completed",
    "year": "2023",
    "tag": "Blockchain",
    "priority": "High",
    "quarter": "Q3"
  },
  {
    "name": "Client Protocol",
    "description": "Accept multiple occurences of the same transactions. Avoid excluding entire block due to collision.",
    "status": "Completed",
    "year": "2023",
    "tag": "Blockchain",
    "priority": "High",
    "quarter": "Q4"
  },
  {
    "name": "Homomorphic Encryption",
    "description": "Use ElGamal to provide privacy on transferred amounts and wallet balances.",
    "status": "Completed",
    "year": "2024",
    "tag": "Blockchain",
    "priority": "High",
    "quarter": "Q1"
  },
  {
    "name": "Difficulty Adjustement",
    "description": "Use Kalman Filter to estimate the network's hash rate and adjust the difficulty target accurately.",
    "status": "Completed",
    "year": "2024",
    "tag": "Blockchain",
    "priority": "High",
    "quarter": "Q1"
  },
  {
    "name": "XELIS Hash",
    "description": "New CPU and GPU friendly algo. Memory focused and FPGAs, ASIC resistance.",
    "status": "Completed",
    "year": "2024",
    "tag": "Blockchain",
    "priority": "High",
    "quarter": "Q1"
  },
  {
    "name": "Block Explorer",
    "description": "Interface to track and verify txs on the network. Graphic to view the BlockDAG.",
    "status": "Completed",
    "year": "2024",
    "tag": "App",
    "priority": "High",
    "quarter": "Q1"
  },
  {
    "name": "Genesix Wallet",
    "description": "New official XELIS wallet written in Flutter.",
    "status": "Completed",
    "year": "2024",
    "tag": "App",
    "priority": "High",
    "quarter": "Q1"
  },
  {
    "name": "Documentations",
    "description": "Comprehensive project resources: detailed guides, feature overviews, APIs, SDKs, and more.",
    "status": "Completed",
    "year": "2024",
    "tag": "App",
    "priority": "High",
    "quarter": "Q1"
  },
  {
    "name": "Project Mainnet Launch",
    "description": "The mainnet was launched on April 20, 2024, at 3PM UTC.",
    "status": "Completed",
    "year": "2024",
    "tag": "Blockchain",
    "priority": "High",
    "quarter": "Q2"
  },
  {
    "name": "XELIS Hash V2",
    "description": "Improvement on all stages.",
    "status": "Completed",
    "year": "2024",
    "tag": "Blockchain",
    "priority": "High",
    "quarter": "Q2"
  },
  {
    "name": "Multisig",
    "description": "Multi-signature wallet: all keys to spend, one to view all balances.",
    "status": "Completed",
    "year": "2024",
    "tag": "Blockchain",
    "priority": "Mid",
    "quarter": "Q4"
  },
  {
    "name": "XVM Playground",
    "description": "An accessible webpage to experiment with coding in the XELIS programming language (SILEX).",
    "status": "Completed",
    "year": "2024",
    "tag": "App",
    "priority": "Mid",
    "quarter": "Q4"
  },
  {
    "name": "Testnet Smart Contracts",
    "description": "Integration of XVM into the XELIS blockchain core. Write decentralized code.",
    "status": "Completed",
    "year": "2024",
    "tag": "Blockchain",
    "priority": "High",
    "quarter": "Q4"
  },
  {
    "name": "Multi Thread Txs",
    "description": "Improve transaction verification to handle high TPS.",
    "status": "Completed",
    "year": "2025",
    "tag": "Blockchain",
    "priority": "High",
    "quarter": "Q1"
  },
  {
    "name": "RocksDB",
    "description": "Replace the Sled database with RocksDB to drastically improve storage performance, stability, and size.",
    "status": "Completed",
    "year": "2025",
    "tag": "Blockchain",
    "priority": "High",
    "quarter": "Q2"
  },
  {
    "name": "Smart Contracts Mainnet",
    "description": "Launch Smart Contracts on the mainnet, enabling decentralized applications and programmable transactions.",
    "status": "Completed",
    "year": "2025",
    "tag": "Blockchain",
    "priority": "High",
    "quarter": "Q4"
  },
  {
    "name": "Smart Contracts improvements",
    "description": "Add new features and optimizations to the Smart Contract platform based on community feedback and usage patterns.",
    "status": "Completed",
    "year": "2026",
    "tag": "Blockchain",
    "priority": "High",
    "quarter": ""
  },
  {
    "name": "BlockDAG Improvements",
    "description": "Ongoing enhancements to the BlockDAG structure to improve scalability, security, and efficiency of the network.",
    "status": "Completed",
    "year": "2026",
    "tag": "Blockchain",
    "priority": "High",
    "quarter": ""
  },
  {
    "name": "Confidential Transfers on Contracts",
    "description": "Enable confidential value transfers within smart contracts while preserving transaction privacy.",
    "status": "Planned",
    "year": "",
    "tag": "Blockchain",
    "priority": "High",
    "quarter": ""
  },
  {
    "name": "Smart Contract Tools & Features",
    "description": "Expand the smart contract ecosystem with developer tools and additional features for building decentralized applications.",
    "status": "Planned",
    "year": "",
    "tag": "Blockchain",
    "priority": "Mid",
    "quarter": ""
  }
]
